import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'event-sponsorship',
  templateUrl: './event-sponsorship.component.html',
  styleUrls: ['./event-sponsorship.component.css','../admin.css']
})
export class EventSponsorshipComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/event-sponsorship/event-sponsorship.component.ts